import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class IncomeService {

  constructor(private http: HttpClient) {}

  getIncomeData(formsId: number): Observable<any> {
    return this.http.get(`${environment.api_guia}forms/${formsId}/income-taxes`);
  }

  updateIncomeData(formsId: number, IncomeId: number, data: any): Observable<any> {
    return this.http.patch(`${environment.api_guia}forms/${formsId}/income-taxes/${IncomeId}`, data);
  }
}
